import { UserRole } from 'src/graphql/generated/graphql.generated';

export enum LandingPage {
  Org = 'Org',
  Ops = 'Ops',
  Insights = 'Insights',
  FleetStatus = 'FleetStatus',
}

export interface User {
  uid?: string;
  employee_id?: string;
  username?: string;
  emailaddress?: string;
  roles: string[];
  companycode?: string;
  firstname?: string;
  lastname?: string;
  middlename?: string;
  department?: string;
  title?: string;
  token?: string;
  tokenexpire?: any;
  isPilot: boolean;
  isAmghUser: boolean;
  impersonatedBy?: string;
  userRoles: UserRole[];
  fetched: boolean;
  personId?: string;
  allCompaniesAccessible?: boolean;
  allBasesAccessible?: boolean;
  landingPage?: LandingPage;
}

export interface Credentials {
  username: string;
  password: string;
  impersonateAs: string;
}

export interface TokenDataDto {
  impersonatedBy?: string;
  accessToken?: string;
  exp?: string;
  claims: [
    {
      type: string;
      value: string;
    },
  ];
}
